export const ANNOTATION_TOPIC = 'wl_annotation';
export const ANNOTATION_TYPE = 'wl_annotation';

export const AnnotationOp = {
  begin: 'begin',
  points: 'points',
  end: 'end',
  undo: 'undo',
  clear: 'clear',
  erase: 'erase',
  hostOverlay: 'host_overlay',
};

export const ANNOTATION_COLORS = {
  red: '#E53935',
  blue: '#1E88E5',
  green: '#43A047',
  yellow: '#FDD835',
  black: '#212121',
};

export const BRUSH_SIZES = {
  small: 2,
  medium: 4,
  large: 8,
};

export const POINTS_THROTTLE_MS = 33;

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeAnnotationMessage(payload) {
  return encoder.encode(JSON.stringify(payload));
}

export function decodeAnnotationMessage(data) {
  try {
    const raw = typeof data === 'string' ? data : decoder.decode(data);
    const msg = JSON.parse(raw);
    if (!msg || msg.type !== ANNOTATION_TYPE) return null;
    return msg;
  } catch {
    return null;
  }
}

/** Letterboxed content rect inside a contain-fit stage. */
export function contentRect(stageW, stageH, contentAspect) {
  if (!stageW || !stageH || !contentAspect) {
    return { x: 0, y: 0, w: stageW || 0, h: stageH || 0 };
  }
  const stageAspect = stageW / stageH;
  if (stageAspect > contentAspect) {
    const h = stageH;
    const w = h * contentAspect;
    return { x: (stageW - w) / 2, y: 0, w, h };
  }
  const w = stageW;
  const h = w / contentAspect;
  return { x: 0, y: (stageH - h) / 2, w, h };
}

export function normalizePoint(localX, localY, stageW, stageH, contentAspect) {
  const rect = contentRect(stageW, stageH, contentAspect);
  if (!rect.w || !rect.h) return null;
  const x = (localX - rect.x) / rect.w;
  const y = (localY - rect.y) / rect.h;
  if (x < 0 || x > 1 || y < 0 || y > 1) return null;
  return { x, y };
}
